export type GeoPoint={latitude:number;longitude:number};
export type WorldPoint={x:number;y:number};
export type MapTile={key:string;urlX:number;y:number;left:number;top:number};

export function recordedGeoPoint(latitude:unknown,longitude:unknown):GeoPoint|undefined {
  return typeof latitude==='number'&&typeof longitude==='number'&&Number.isFinite(latitude)&&Number.isFinite(longitude)&&latitude>=-90&&latitude<=90&&longitude>=-180&&longitude<=180?{latitude,longitude}:undefined;
}

export const MAP_TILE_SIZE=256;
export const MAP_ZOOM=18;
const MAX_LATITUDE=85.05112878;

export function projectGeoPoint(point:GeoPoint,zoom=MAP_ZOOM):WorldPoint{
  const latitude=Math.max(-MAX_LATITUDE,Math.min(MAX_LATITUDE,point.latitude));
  const scale=MAP_TILE_SIZE*2**zoom;
  const sine=Math.sin(latitude*Math.PI/180);
  return{x:(point.longitude+180)/360*scale,y:(0.5-Math.log((1+sine)/(1-sine))/(4*Math.PI))*scale};
}

export function unprojectWorldPoint(point:WorldPoint,zoom=MAP_ZOOM):GeoPoint{
  const scale=MAP_TILE_SIZE*2**zoom;
  const longitude=point.x/scale*360-180;
  const n=Math.PI-2*Math.PI*point.y/scale;
  return{latitude:180/Math.PI*Math.atan(Math.sinh(n)),longitude:((longitude+540)%360)-180};
}

export function mapTiles(centre:GeoPoint,width:number,height:number,zoom=MAP_ZOOM):MapTile[]{
  const world=projectGeoPoint(centre,zoom),tilesPerAxis=2**zoom;
  const firstX=Math.floor((world.x-width/2)/MAP_TILE_SIZE),lastX=Math.floor((world.x+width/2)/MAP_TILE_SIZE);
  const firstY=Math.max(0,Math.floor((world.y-height/2)/MAP_TILE_SIZE)),lastY=Math.min(tilesPerAxis-1,Math.floor((world.y+height/2)/MAP_TILE_SIZE));
  const tiles:MapTile[]=[];
  for(let y=firstY;y<=lastY;y++)for(let x=firstX;x<=lastX;x++)tiles.push({
    key:`${x}:${y}`,urlX:((x%tilesPerAxis)+tilesPerAxis)%tilesPerAxis,y,
    left:x*MAP_TILE_SIZE-world.x+width/2,top:y*MAP_TILE_SIZE-world.y+height/2,
  });
  return tiles;
}

export function moveGeoPoint(point:GeoPoint,deltaX:number,deltaY:number,zoom=MAP_ZOOM):GeoPoint{
  const world=projectGeoPoint(point,zoom);
  return unprojectWorldPoint({x:world.x+deltaX,y:world.y+deltaY},zoom);
}
